import * as React from 'react';
import { CustomStatus } from "../../help/status";
// import { CustomStackGrid, GradientTypographyGrid } from "../../../styles/style";
// import { GradienBorderColorIcon, GradienDeleteIcon } from "../../../component/icons/icon-gradient";

import { useContext } from "react";
import DataSourceContext from "../../../context/DataSourceMngContext";
import { Box, IconButton, Typography, Tooltip, Stack } from "@mui/material";
import {
  GradienCheckCircleIcon,
  GradienCancelIcon,
} from "../../../component/icons/icon-gradient";
import { CustomStackGrid, GradientTypographyGrid, CustomStackRow, CustomAutocomplete, StyledPopper, StyledTextField } from "../../../styles/style";
import { GradienRemoveRedEyeIcon, GradienCalculateIcon, GradienBorderColorIcon, GradienDeleteIcon } from "../../../component/icons/icon-gradient";

export const columns_huawei = [
    { field: 'lastModified', headerName: 'Last Modified', flex: 1 },
    {
        field: 'id',
        headerName: 'Device ID',
        flex: 1,
        renderCell: (params) => (
            <GradientTypographyGrid>
                {params.row.id}
            </GradientTypographyGrid>
        ),
    },
    { field: 'lastName', headerName: 'Last name', flex: 1 },
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'location', headerName: 'Location', flex: 1 },
    { field: 'lat_long', headerName: 'Latitude, Longitude', flex: 1 },
    {
        field: "status",
        headerName: "Status",
        sortable: false,
        width: 160,
        pinned: 'right', // คงที่ทางด้านขวา
        renderCell: (params) => CustomStatus(params.row.status),
    },
    {
        field: "action",
        headerName: "Action",
        sortable: false,
        width: 70,
        pinned: 'right', // คงที่ทางด้านขวา
        renderCell: (params) => (
            <CustomStackGrid direction="row" spacing={0.5}>
                <GradienBorderColorIcon />
                <GradienDeleteIcon />
            </CustomStackGrid>
        ),
    },
];

export const columns_huawei_data = [
  {
    field: "id",
    headerName: "ID",
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "create_at",
    headerName: "Date",
    headerAlign: "center",
    width: 200,
    renderCell: (params) => {
      let content;
    
      if (params.row.create_at) {
        const date = new Date(params.row.create_at);
        content = `${date.toLocaleDateString("th-TH")}`;
      } else {
        content = "-";
      }
    
      return (
        <CustomStackRow direction="row" spacing={0.5} alignItems="center">
          <Typography sx={{ fontSize: "14px" }} align="start">
            {content}
          </Typography>
        </CustomStackRow>
      );
    },    
  },
  {
    field: "total",
    headerName: "Total",
    flex: 1,
    headerAlign: "center",
    sortable: false,
    renderCell: (params) => {
      const { file_name, total } = params.row;
      return (
        <CustomStackRow direction="row" spacing={0.5} alignItems="center">
          <Tooltip
            title={
              <Box>
                <Typography sx={{ fontSize: "14px" }} align="start">
                  File(s)
                </Typography>
                <ul className="w-full mt-1 overflow-y-hidden">
                  {file_name.map((item, index) => (
                    <li key={`file-${index}`} className="w-full">
                      <Typography
                        sx={{ fontSize: "14px" }}
                        align="start"
                        noWrap
                      >
                        {index + 1}. {item}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </Box>
            }
            enterDelay={500}
            leaveDelay={200}
          >
            <Typography
              sx={{ fontSize: "14px" }}
              align="center"
              className="cursor-pointer"
            >
              {total}
            </Typography>
          </Tooltip>
        </CustomStackRow>
      );
    },
  },
  {
    field: "total_success",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderHeader: () => (
      <Tooltip title={<Typography sx={{ fontSize: "14px" }} align="start">Successfully processed items</Typography>} arrow>
        <span>
          <GradienCheckCircleIcon sx={{ fontSize: 25 }} />
        </span>
      </Tooltip>
    ),    
    renderCell: (params) => {
      const { total_success } = params.row;
      return (
        <CustomStackRow direction="row" spacing={0.5} alignItems="center">
          <Typography sx={{ fontSize: "14px" }} align="center">
            {total_success}
          </Typography>
        </CustomStackRow>
      );
    },
  },
  {
    field: "total_failed",
    sortable: false,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderHeader: () => (
      <Tooltip title={<Typography sx={{ fontSize: "14px" }} align="start">Needs review</Typography>} arrow>
        <span>
          <GradienCancelIcon sx={{ fontSize: 25 }} />
        </span>
      </Tooltip>
    ),    
    renderCell: (params) => {
      const { total_failed } = params.row;
      return (
        <CustomStackRow direction="row" spacing={0.5} alignItems="center">
          <Typography sx={{ fontSize: "14px" }} align="center">
            {total_failed}
          </Typography>
        </CustomStackRow>
      );
    },
  },
  {
    field: "in_progress",
    headerName: "Status",
    sortable: false,
    width: 300,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <CustomStackRow direction="row" spacing={0.5} alignItems="center">
          <Typography
            sx={{
              fontSize: "14px",
              color: params?.value ? "info.main" : "primary.main",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {params?.value ? "Processing" : "Done"}
          </Typography>
        </CustomStackRow>
      );
    },
  },
  {
    field: "action",
    headerName: "Action",
    sortable: false,
    width: 100,
    pinned: "right",
    renderCell: (params) => <ActionCell params={params} />,
  },
];

const ActionCell = (props) => {
  const { params } = props;
  // const rowIndex = params.api.getSortedRowIds().indexOf(params.id);
  const { setDialog, fetchHistory } = useContext(DataSourceContext);

  const handleClick = () => {
    fetchHistory(params?.row?.id);
    setDialog("device_details", true);
  };

  return (
    <CustomStackGrid direction="row" spacing={0.5}>
      {params?.row?.in_progress ? null : (
        <>
          <IconButton onClick={handleClick}>
            <GradienRemoveRedEyeIcon fontSize={20} />
          </IconButton>
        </>
      )}
    </CustomStackGrid>
  );
};